import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export class ImagePreview extends React.PureComponent {
    render() {
        return (_jsx("img", { crossOrigin: 'anonymous', title: this.props.label, alt: this.props.label, style: {
                width: this.props.width,
                height: this.props.height,
                maxWidth: 'none',
            }, src: this.props.src }));
    }
}
//# sourceMappingURL=preview.js.map